import { makeReducerFromScaffold, bindEntityScaffold } from '@classpass/saga-tools';
import { combineReducers } from 'redux';
import * as entities from './entities';

export default combineReducers(
  Object.keys(entities).reduce((memo, key) => ({ ...memo, [key]: makeReducerFromScaffold(entities[key]) }), {})
);

const bindForReducer = name => bindEntityScaffold(entities[name], state => state.entities[name]);

export const achievementsPastReservations = bindForReducer('achievementsPastReservations');
export const achievementsPastReservationsCount = bindForReducer('achievementsPastReservationsCount');
export const activityList = bindForReducer('activityList');
export const babelfishGetSupportedLocales = bindForReducer('babelfishGetSupportedLocales');
export const cancelReservation = bindForReducer('cancelReservation');
export const cancelFlowStep = bindForReducer('cancelFlowStep');
export const charges = bindForReducer('charges');
export const classBundlesByMsa = bindForReducer('classBundlesByMsa');
export const classesByVenue = bindForReducer('classesByVenue');
export const classInfoByVenueAlias = bindForReducer('classInfoByVenueAlias');
export const cms = bindForReducer('cms');
export const cmsLegalContent = bindForReducer('cmsLegalContent');
export const cmsWebContent = bindForReducer('cmsWebContent');
export const cmsWebData = bindForReducer('cmsWebData');
export const contentTags = bindForReducer('contentTags');
export const contentTagsV2 = bindForReducer('contentTagsV2');
export const createGift = bindForReducer('createGift');
export const createReservation = bindForReducer('createReservation');
export const createSubscription = bindForReducer('createSubscription');
export const createSubscriptionCache = bindForReducer('createSubscriptionCache');
export const createVideoReservation = bindForReducer('createVideoReservation');
export const creditBounds = bindForReducer('creditBounds');
export const dashFeatureById = bindForReducer('dashFeatureById');
export const defaultPromotion = bindForReducer('defaultPromotion');
export const emailOptIn = bindForReducer('emailOptIn');
export const featureById = bindForReducer('featureById');
export const filtersByHash = bindForReducer('filtersByHash');
export const filtersByQuery = bindForReducer('filtersByQuery');
export const fitnessDeviceTracking = bindForReducer('fitnessDeviceTracking');
export const fitnessTrendsMember = bindForReducer('fitnessTrendsMember');
export const friendbuy = bindForReducer('friendbuy');
export const geocode = bindForReducer('geocode');
export const getAddressRequirements = bindForReducer('getAddressRequirements');
export const getCountries = bindForReducer('getCountries');
export const glsLocation = bindForReducer('glsLocation');
export const holdPlanByMsa = bindForReducer('holdPlanByMsa');
export const isUserVerified = bindForReducer('isUserVerified');
export const jobById = bindForReducer('jobById');
export const jobs = bindForReducer('jobs');
export const keywordAutocomplete = bindForReducer('keywordAutocomplete');
export const leaderboardJoinClass = bindForReducer('leaderboardJoinClass');
export const leaderboardLeaveClass = bindForReducer('leaderboardLeaveClass');
export const leaderboardUpdateClientStatus = bindForReducer('leaderboardUpdateClientStatus');
export const leaderboardUpdateHeartrate = bindForReducer('leaderboardUpdateHeartrate');
export const liveSubscription = bindForReducer('liveSubscription');
export const liveVideoDetail = bindForReducer('liveVideoDetail');
export const liveVideos = bindForReducer('liveVideos');
export const locationAutocomplete = bindForReducer('locationAutocomplete');
export const locationsByMsa = bindForReducer('locationsByMsa');
export const locationSearch = bindForReducer('locationSearch');
export const modals = bindForReducer('modals');
export const movementByAlias = bindForReducer('movementByAlias');
export const msaById = bindForReducer('msaById');
export const msaCreditStatById = bindForReducer('msaCreditStatById');
export const msaOfferById = bindForReducer('msaOfferById');
export const msas = bindForReducer('msas');
export const nearbyPopularVenues = bindForReducer('nearbyPopularVenues');
export const onDemandVideos = bindForReducer('onDemandVideos');
export const pageContentByKey = bindForReducer('pageContentByKey');
export const pageIndexByKey = bindForReducer('pageIndexByKey');
export const paymentTypes = bindForReducer('paymentTypes');
export const planById = bindForReducer('planById');
export const plansByMsa = bindForReducer('plansByMsa');
export const postApplication = bindForReducer('postApplication');
export const productSalesTaxEstimate = bindForReducer('productSalesTaxEstimate');
export const promotionByAlias = bindForReducer('promotionByAlias');
export const promotionByAliasAndCoordinates = bindForReducer('promotionByAliasAndCoordinates');
export const purchaseClassBundle = bindForReducer('purchaseClassBundle');
export const redeemSubscriptionCode = bindForReducer('redeemSubscriptionCode');
export const relatedFiltersByHash = bindForReducer('relatedFiltersByHash');
export const reviewsForClass = bindForReducer('reviewsForClass');
export const reviewsForClassV2 = bindForReducer('reviewsForClassV2');
export const reviewsForVenue = bindForReducer('reviewsForVenue');
export const reviewsForVenueV2 = bindForReducer('reviewsForVenueV2');
export const saveOffer = bindForReducer('saveOffer');
export const saveCancelReasonCode = bindForReducer('saveCancelReasonCode');
export const scheduleById = bindForReducer('scheduleById');
export const scheduleForClass = bindForReducer('scheduleForClass');
export const scheduleForVenue = bindForReducer('scheduleForVenue');
export const searchLayoutByName = bindForReducer('searchLayoutByName');
export const searchLocationAutocomplete = bindForReducer('searchLocationAutocomplete');
export const searchLocationDetails = bindForReducer('searchLocationDetails');
export const searchMovements = bindForReducer('searchMovements');
export const searchSchedules = bindForReducer('searchSchedules');
export const similarVenues = bindForReducer('similarVenues');
export const studioBookmarks = bindForReducer('studioBookmarks');
export const taggedContent = bindForReducer('taggedContent');
export const tagList = bindForReducer('tagList');
export const taxRate = bindForReducer('taxRate');
export const userAccountSummary = bindForReducer('userAccountSummary');
export const userActionCampaign = bindForReducer('userActionCampaign');
export const userActionCampaignEvent = bindForReducer('userActionCampaignEvent');
export const userAnnouncements = bindForReducer('userAnnouncements');
export const userBillingDetails = bindForReducer('userBillingDetails');
export const userCancelMembership = bindForReducer('userCancelMembership');
export const userCancelReasons = bindForReducer('userCancelReasons');
export const userCreditBalance = bindForReducer('userCreditBalance');
export const userCreditBalanceBreakdown = bindForReducer('userCreditBalanceBreakdown');
export const userInactivePermissions = bindForReducer('userInactivePermissions');
export const userLogout = bindForReducer('userLogout');
export const userPastReservations = bindForReducer('userPastReservations');
export const userPastReservationsCount = bindForReducer('userPastReservationsCount');
export const userPermissions = bindForReducer('userPermissions');
export const userProfile = bindForReducer('userProfile');
export const userSignUpEmail = bindForReducer('userSignUpEmail');
export const userSignUpFacebook = bindForReducer('userSignUpFacebook');
export const userSubscription = bindForReducer('userSubscription');
export const userUpcomingReservations = bindForReducer('userUpcomingReservations');
export const userVerifyEmail = bindForReducer('userVerifyEmail');
export const userVideoReservations = bindForReducer('userVideoReservations');
export const venueByIdV2 = bindForReducer('venueByIdV2');
export const venueList = bindForReducer('venueList');
export const venueListV2 = bindForReducer('venueListV2');
export const venueOtherLocations = bindForReducer('venueOtherLocations');
export const venueTopTenPages = bindForReducer('venueTopTenPages');
export const verifyGift = bindForReducer('verifyGift');
export const videoBookmarks = bindForReducer('videoBookmarks');
export const videoCollection = bindForReducer('videoCollection');
export const videoCompletedViews = bindForReducer('videoCompletedViews');
export const videoDetails = bindForReducer('videoDetails');
export const videos = bindForReducer('videos');
export const videosFilters = bindForReducer('videosFilters');
export const videoStacks = bindForReducer('videoStacks');
export const videoTracking = bindForReducer('videoTracking');
export const videoViewRatings = bindForReducer('videoViewRatings');
export const waitlistRequest = bindForReducer('waitlistRequest');
export const zipCodeToLatLng = bindForReducer('zipCodeToLatLng');
